module.exports = __webpack_public_path__ + "static/media/dumbbell.7f05ac62.svg";